import { baseApi } from 'services/baseApi';
import { LocalStorageService } from 'services';
import { saveResourceSystemSettings } from 'app/resource/slices';
import { AppConstants } from 'constants/index';
import { cacheTags } from 'constants/cacheTags';
import { Meta } from 'types';
import { SystemSettings as SystemSettingsType } from 'app/resource/types/systemSettings';

export const systemSettings = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getResourceSystemSettings: builder.query<SystemSettingsType, Meta>({
      query: ({ skipGlobalLoading } = {}) => {
        const { ReportingAdmin, SystemSettings, Resource } = AppConstants.api;
        return {
          url: [ReportingAdmin, SystemSettings, Resource],
          meta: { skipGlobalLoading },
        };
      },
      providesTags: [cacheTags.ResourceSystemSettings],
      async onQueryStarted(arg: Meta, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        dispatch(saveResourceSystemSettings(data));
        LocalStorageService.set('systemSettings', data);
      },
    }),
  }),
});

export const { useLazyGetResourceSystemSettingsQuery } = systemSettings;
